import React from 'react';

const TrustBadge = ({ icon, title, description }) => {
  return (
    <div className="trust-badge" data-testid={`trust-badge-${title.toLowerCase().replace(/\s+/g, '-')}`}>
      <div className="text-accent-main text-3xl mb-2">{icon}</div>
      <h4 className="font-heading font-semibold text-sm text-text-primary">{title}</h4>
      <p className="text-xs text-text-secondary">{description}</p>
    </div>
  );
};

export default TrustBadge;
